import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';
import { width } from './SaveButton';

export default styled(AvInput)`
  && {
    height: calc(60px / 2);
  }
  padding-right: ${width};
  padding-left: 5px;
`;
